import { Controller } from "@hotwired/stimulus"
import ace from "ace-builds"

export default class extends Controller {
  static targets = ["textarea", "editor"]

  connect() {
    this.initializeEditor()
  }

  disconnect() {
    if (this.editor) {
      this.editor.destroy()
    }
  }

  initializeEditor() {
    // Create the editor container
    this.editorContainer = document.createElement('div')
    this.editorContainer.style.height = '400px'
    this.editorContainer.style.border = '1px solid #d1d5db'
    this.editorContainer.style.borderRadius = '0.375rem'
    this.editorContainer.style.fontSize = '14px'
    
    // Insert the editor after the textarea
    this.textareaTarget.parentNode.insertBefore(this.editorContainer, this.textareaTarget.nextSibling)
    
    // Hide the original textarea
    this.textareaTarget.style.display = 'none'
    
    // Initialize Ace Editor
    this.editor = ace.edit(this.editorContainer)
    this.editor.setTheme("ace/theme/monokai")
    this.editor.session.setMode("ace/mode/html")
    this.editor.setValue(this.textareaTarget.value)
    this.editor.setShowPrintMargin(false)
    this.editor.setFontSize(14)
    
    // Sync with textarea on change
    this.editor.on('change', () => {
      this.textareaTarget.value = this.editor.getValue()
    })
    
    // Set initial value
    this.editor.setValue(this.textareaTarget.value || '')
  }
}
